import React, { useState } from "react";
import "../style/MyCarBoletin.css";

function formatNumberWithCommas(number) {
  if (number === undefined || number === null || number === "") return "0";
  return Number(number)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function formatFin(value) {
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  try {
    return d.toLocaleDateString("es-HN", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } catch (e) {
    return d.toLocaleDateString();
  }
}

function AuctionBoletin({ auction, onSelectionChange }) {
  const car = auction.Carro || {};
  const imageUrl = (car.imagenes?.[0] || "").replace("http://", "https://");
  const [checked, setChecked] = useState(false);

  const setSelection = (next) => {
    if (next === checked) return;
    setChecked(next);
    onSelectionChange(auction, next);
  };

  const handleRowClick = () => {
    setSelection(!checked);
  };

  const handleCheckboxChange = (event) => {
    setSelection(event.target.checked);
  };

  return (
    <div
      className={`bp-row${checked ? " is-selected" : ""}`}
      onClick={handleRowClick}
    >
      <input
        type="checkbox"
        className="bp-checkbox"
        checked={checked}
        onChange={handleCheckboxChange}
        onClick={(e) => e.stopPropagation()}
        aria-label={`Seleccionar ${car.marca} ${car.modelo}`}
      />
      {imageUrl ? (
        <img className="bp-thumb" src={imageUrl} alt={car.modelo} />
      ) : (
        <div className="bp-thumb" />
      )}
      <div className="bp-info">
        <div className="bp-title-row">
          <p className="bp-title">
            {car.marca} {car.modelo} {car.anio}
          </p>
          {car.lote && car.lote !== "0" && (
            <span className="bp-lote">Lote {car.lote}</span>
          )}
        </div>
        <div className="bp-specs">
          <span className="bp-spec">
            <strong>Termina:</strong>
            {formatFin(auction.Fin)}
          </span>
        </div>
      </div>
      <div className="bp-prices">
        <span className="bp-price-label">Inicia en</span>
        <span className="bp-price" translate="no">
          L.{formatNumberWithCommas(auction.PrecioInicial)}
        </span>
      </div>
    </div>
  );
}

export default AuctionBoletin;
